import clsx from "clsx";
import React from "react";
import { Field, FieldWithPickupOptions } from "types";
import { NoTranslate } from "../Common/NoTranslate";

interface QuestionnaireDescriptionProps {
    field: Field | FieldWithPickupOptions;
    className?: string;
}

export const QuestionnaireDescription = ({ field, className }: QuestionnaireDescriptionProps) => {
    if (field.url) {
        return (
            <NoTranslate as="div" className={clsx("mb-2", className)}>
                <a target="_blank" rel="noopener noreferrer" href={field.url}>
                    {field.description ?? field.url}
                </a>
            </NoTranslate>
        );
    }

    if (field.description) {
        return (
            <NoTranslate as="div" className={clsx("mb-2", className)}>
                {field.description}
            </NoTranslate>
        );
    }

    return null;
};
